{
  "page_title": "Clients",
  "table": {
    "name": "Name",
    "code": "Code",
    "country": "Country",
    "created": "Created",
    "click_to_edit": "Click to edit",
    "type": "Type",
    "features": "Features",
    "no_matches": "No customers matching the search"
  },
  "create": {
    "title": "Create new client",
    "subtitle": "Add a new golf club or organisation to the system",
    "breadcrumb": "New client",
    "success": "Client \"{{name}}\" created successfully!",
    "error": "Failed to create client: {{message}}",
    "submit_button": "Create client"
  },
  "edit": {
    "breadcrumb": "Edit",
    "success": "Client \"{{name}}\" updated successfully!",
    "error": "Failed to update client: {{message}}",
    "submit_button": "Update client",
    "error_loading": "Error loading client",
    "back_to_list": "Back to client list"
  },
  "delete": {
    "danger_zone": "Danger zone",
    "danger_zone_description": "When you delete a client, it will be soft-deleted and all manager associations will be removed. This action affects all users associated with this client.",
    "button": "Delete client",
    "confirm_header": "Delete client \"{{name}}\"",
    "confirm_body": "Are you sure you want to delete client \"{{name}}\"?\n\nThis will:\n• Soft-delete the client (set deletedAt timestamp)\n• Remove all manager associations\n• Make the client inaccessible to users\n\nThis action can be reviewed in system logs, but should be done carefully.",
    "confirm_button": "Delete client",
    "success": "Client \"{{name}}\" has been deleted successfully.",
    "error": "Failed to delete client: {{message}}"
  },
  "form": {
    "tabs": {
      "basic": "Basic info",
      "contact": "Contact",
      "payment": "Settings",
      "managers": "Users"
    },
    "fields": {
      "name": {
        "label": "Client name",
        "placeholder": "Enter golf club name",
        "help": "The official registered name of the golf club or organisation."
      },
      "code": {
        "label": "Client code",
        "placeholder": "club-code",
        "help": "Unique identifier used in URLs. Only lowercase letters, numbers and hyphens.",
        "available": "Code \"{{code}}\" is available",
        "taken": "Code \"{{code}}\" is already taken"
      },
      "display_name": {
        "label": "Display name",
        "placeholder": "Short display name (optional)",
        "help": "Optional shorter name for display purposes."
      },
      "country": {
        "label": "Country",
        "placeholder": "Select country",
        "help": "The country where the golf club is located."
      },
      "paytrailMerchantId": {
        "label": "Paytrail merchant ID",
        "placeholder": "",
        "help": "Shop-in-Shop sub-merchant ID for payment splitting."
      },
      "vatRate": {
        "label": "VAT rate",
        "placeholder": "",
        "help": "Default value-added tax rate (e.g. 13.5%)."
      },
      "commissionRate": {
        "label": "Commission rate",
        "placeholder": "",
        "help": "XenGolf service commission on payments (e.g. 2.5%)."
      },
      "commissionFixed": {
        "label": "Fixed commission (€)",
        "placeholder": "",
        "help": "Fixed commission in euros deducted from payments accounted to tenant."
      },
      "batch_submission_time": {
        "label": "eBirdie submission time",
        "help": "Time of day when results are automatically submitted to eBirdie."
      },
      "latitude": {
        "label": "Latitude",
        "placeholder": "e.g. 60.1699"
      },
      "longitude": {
        "label": "Longitude",
        "placeholder": "e.g. 24.9384"
      },
      "ebirdie_club": {
        "label": "Fetch data from eBirdie",
        "title": "Select eBirdie club",
        "placeholder": "Select club",
        "loading": "Loading clubs...",
        "prefilling": "Fetching data...",
        "error": "Failed to fetch clubs",
        "help": "Select a club to prefill the form with eBirdie data.",
        "select_button": "Select",
        "skip_button": "Continue without selection"
      },
      "type": {
        "label": "Customer type",
        "club": "Club",
        "society": "Society",
        "union": "Union",
        "help": "Customer type: Club, Society or Union. Cannot be changed after creation."
      },
      "ebirdieEnabled": {
        "label": "eBirdie enabled",
        "help": "When disabled, eBirdie functions are hidden from competition management and scores are not sent to eBirdie."
      },
      "system36Enabled": {
        "label": "System 36 enabled",
        "help": "When enabled, System 36 is available as a score type for a series."
      },
      "addOnsEnabled": {
        "label": "Add-ons enabled",
        "help": "When enabled, add-on management is visible in the Administration menu."
      },
      "pollsEnabled": {
        "label": "Polls enabled",
        "help": "When enabled, course feedback poll management is visible in the Admin menu and players can be shown a poll after their round."
      }
    },
    "validation": {
      "name_required": "Client name is required",
      "name_min_length": "Client name must be at least 2 characters",
      "code_required": "Client code is required",
      "code_pattern": "Client code may only contain lowercase letters, numbers and hyphens",
      "code_min_length": "Client code must be at least 3 characters",
      "code_max_length": "Client code may not exceed 50 characters",
      "email_invalid": "Invalid email address",
      "vat_required_with_merchant": "VAT rate is required when merchant ID is set"
    },
    "unsaved_changes": "You have unsaved changes",
    "saving": "Saving...",
    "save": "Save",
    "cards": {
      "features": "Features",
      "payment": "Payment"
    }
  },
  "managers": {
    "current": "Current users",
    "no_managers": "No users assigned to this client",
    "no_managers_help": "Add users",
    "add_manager": "Add user",
    "search_placeholder": "Search users by email or name...",
    "reload": "Refresh available users",
    "loading": "Loading users...",
    "no_results": "No users found for \"{{searchTerm}}\"",
    "no_results_help": "Try a different search term",
    "no_available": "No available users",
    "no_available_help": "All users are already assigned to clients or removed.",
    "showing_first_10": "Showing first 10 results. Keep typing to narrow down.",
    "remove_manager": "Remove user"
  },
  "list": {
    "search_placeholder": "Search by name or code",
    "type_filter_all": "All types",
    "features": {
      "payments": "Payments",
      "ebirdie": "eBirdie",
      "system36": "System 36",
      "addons": "Add-ons",
      "polls": "Polls"
    },
    "feature_enabled": "{{feature}} enabled",
    "feature_disabled": "{{feature}} disabled",
    "legend": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    }
  }
}
